
const MYSTERYSPOOL = '61f05643cfc23be4c2533af1'


export {MYSTERYSPOOL};